
import { defineComponent } from "vue";
import BasicModal from "@/components/modals/BasicModal.vue";
import MainButton from "@/components/other/MainButton.vue";

export default defineComponent({
  name: "CopySectionData",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  components: {
    BasicModal,
    MainButton,
  },
  emits: ["closeModal", "copySectionData"],
  data() {
    return {
      searchDate: "" as string,
    };
  },
  watch: {
    date(newValue) {
      this.searchDate = newValue;
    },
  },
});
